export const LOAD_CATEGORIES_ACTION = 'LOAD_CATEGORIES_ACTION';
export const SET_EDITED_CATEGORY_ACTION = 'SET_EDITED_CATEGORY_ACTION';
export const SELECT_CATEGORY_ACTION = 'SELECT_CATEGORY_ACTION';
export const SAVE_EDITED_CATEGORY_ACTION = 'SAVE_EDITED_CATEGORY_ACTION';
